import { Items } from 'es6/collections/items'
import { SearchTipsCache } from 'es6/collections/search-tips-cache'
import { Collection } from 'es6/components/collection'
import { View } from 'es6/components/view'
import { KEY_CODES } from 'es6/constants'
import { Popup } from 'es6/libs/popup'
import { getJson, getTemplate } from 'helpers/template-helper'
import { currentCurrency } from 'init/current-currency'
import { locationAssign } from 'helpers/redirect-helper'
import locale from 'init/locale'
import $ from 'init/jquery'
import 'es6/libs/jquery-highlight'
import { isNewSearchTipsEnabled } from 'init/is-new-search-tips-enabled'
import { Defaults } from 'es-decorators'
import { fractionNumber } from 'helpers/number-helpers'
import { format } from 'helpers/declination-helper'
import Backbone from 'init/backbone'
import each from 'lodash/each'
import remove from 'lodash/remove'
import { isMobile } from 'init/is-mobile'
import { LS } from 'helpers/storage-helpers'
import { getFilteredUrlParameters, getParamString } from 'helpers/url-helpers'

/**
 * Вид для попапа подсказок.
 */

@Defaults({
  el: '.search-tips',
  timeout: null,
  events: {
    'click .js-popup-close': 'close',
    'click .toggle-tips': 'toggleTips',
    'click .js-delete-from-ls': 'deleteRequestHistoryFromLS',
  },
  cache: null,
  /**
   * Время кэширования
   */
  cacheTime: 7200,
  /**
   * Максимальное количество записи в кэше
   */
  cacheMax: 300,
  prev: '',
  /**
   * Последний отправленный запрос, чтобы можно было заабортить его, если отправляется новый
   */
  lastRequest: null,
  /**
   * Максимальное количество показываемых подсказок для каждой категории
   */
  maxTipsShow: 4,
  /**
   * Состояния подсказок для перерендера поп-апа
   */
  stateTips: {
    Trademarks: true,
    Category: true,
  },
  /**
   * Состояние для перерендера подсказок при их малом количестве
   */
  stateCountTips: false,
  /* Максимальное количество "популярных запросов" */
  MAX_SEARCH_HELP_TIPS: 10,
  /**
   * Стандартная сортировка подсказок для большей отказоустойчивости
   */
  DEFAULT_TIPS_ORDER: ['categories', 'trademarks', 'items'],
})
export class SearchTipsView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (isMobile) {
      this.maxTipsShow = 15
    }
    this.abTest = isNewSearchTipsEnabled
    if (this.abTest) {
      this.maxTipsShow = 11
    }
    const $resultsCatalog = $('.mobile-version .container'),
      $relatedQueries = $('.mobile-version .related-queries')
    this.popup = new Popup(this.$el)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      () => {
        if (!this.abTest && !isMobile) {
          let opener = this.$el.siblings('.search-js-popup-opener')
          this.$el.css({
            width: opener.outerWidth(),
          })
        }
        $resultsCatalog.addClass('not_display')
        $relatedQueries.addClass('not_display')
        this.closeManager()
      }
    )
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE,
      () => {
        $resultsCatalog.removeClass('not_display')
        $relatedQueries.removeClass('not_display')
      }
    )
    this.template = getTemplate('#search-tips-template')
    this.helpTemplate = getTemplate('#search-help-template')
    this.showAllTemplateBtn = getTemplate('#show-all-button-template')
    this.productDeclinations = getJson('#goods-declination-json')
    this.requestsTemplate = getTemplate('#search-tips-requests')
    this.items = new Items()
    this.categories = new Collection()
    this.trademarks = new Collection()
    this.searchHelp = false
    this._initCache()
    this.keyboardControl()
    this.listenTo(Backbone, 'change-currency', this.clearCache)
  }
  /**
   * Устанавливает значение currentUrl
   * @param {string} value - новое значение
   */
  setCurrentUrl (value) {
    this.currentUrl = value
  }
  /**
   * Очищает кэш запросов.
   */
  clearCache () {
    this.cache.reset()
    this.prev = null
  }
  /**
   * Обработка запроса
   * @param {string} query Поисковая строка
   */
  query (query) {
    query = query.trim().toLowerCase()
    if (query.length > 1) {
      this.getSearchTips(query)
    } else if (query.length === 0) {
      this.renderRequests()
    } else {
      this.popup.close()
    }
  }
  /**
   * Ищем подсказки в кэше, либо запрашиваем с сервера
   * @param {string} query Поисковая строка
   */
  getSearchTips (query) {
    let timeout,
      timeDiff,
      cache
    cache = this.cache.get(query)
    clearTimeout(this.timeout)
    if (cache && cache.get('load') !== true) {
      timeDiff = (Date.now() - cache.get('time')) / 1000
      if (timeDiff <= this.cacheTime) {
        this.processData(cache.toJSON(), null, query)
        this.prev = query
        return
      }
      cache.destroy()
    }
    this.cache.add({ id: query, load: true })
    this._abortRequest()
    this.timeout = timeout = setTimeout(() => {
      this.lastRequest = this.model.sync('read', this.model, {
        data: {
          q: query,
        },
        success: resp => {
          this.processData(resp, timeout, query)
          this.prev = query
          resp.id = query
          resp.load = false
          resp.time = Date.now()
          cache = this.cache.get(query)
          if (!cache) {
            cache = new SearchTipsCache({ id: query })
            this.cache.add(cache)
          }
          cache.set(resp)
          cache.save()
          this.cache.sort()
          this._checkOnCacheMax()
        },
      })
    }, 500)
  }
  /**
   * Рендерим историю запросов.
   */
  renderRequests () {
    let requests
    this._abortRequest()
    try {
      requests = JSON.parse(localStorage.getItem('saved_requests')) || []
    } catch (e) {
      requests = []
    }
    const url = location.href
    const urlParams = getParamString(getFilteredUrlParameters(['f', 'sort', 'q'], url))
    if (requests.length) {
      this.$el.html(this.requestsTemplate({
        requests: requests,
        abTest: this.abTest,
        urlParams: urlParams,
      }))
      this.popup.open()
    } else {
      this.$el.html('')
      this.popup.close()
    }
  }
  /**
   * Обновляет данные коллекций
   *
   * @param {Object} data Данные
   * @param {string} timeout Локальный ID таймаута запроса
   * @param {string} query Поисковая строка
   */
  processData (data, timeout, query) {
    this.items.reset(data.items)
    this.categories.reset(data.categories)
    this.trademarks.reset(data.trademarks)
    this.count = data.count
    this.tipsOrder = data.order || this.DEFAULT_TIPS_ORDER
    if (data.search_request.length && isNewSearchTipsEnabled) {
      this.searchHelp = _.slice(data.search_request, 0, this.MAX_SEARCH_HELP_TIPS)
    }
    if (
      this.items.length
      || this.categories.length
      || this.trademarks.length
      || this.count
      || this.searchHelp
    ) {
      if ((this.timeout === timeout || !timeout) && query !== this.prev) {
        this.render(query)
        this.popup.open()
        this.closeManager()
      }
      return
    }
    this.popup.close()
  }
  /**
   * Рендеринг подсказок
   * @param {string} query Поисковая строка
   */
  render (query) {
    const template = this.searchHelp && !isMobile ? this.helpTemplate : this.template
    this.$el.html(template({
      items: this.items.toJSON(),
      categories: this.categories.toJSON(),
      trademarks: this.trademarks.toJSON(),
      fractionNumber: fractionNumber,
      currency: currentCurrency,
      count: this.count,
      units: format(this.count, this.productDeclinations, locale),
      helps: this.searchHelp || [],
      tipsOrder: this.tipsOrder,
    }))
    // Выжидаем, пока DOM обработает новые элементы
    setTimeout(() => {
      this.calculateItemWidth()
      if (query) {
        this.$('.tip .link').highlight(query)
      }
    }, 50)
    this.toggleTips()
    this.rewritePageLinks()
  }
  /**
   * Закрываем попап при нажатии кнопки
   */
  close () {
    this.popup.close()
  }
  /**
   * Инициализация и подготовка кэша.
   * @private
   */
  _initCache () {
    let time = Date.now(),
      old,
      that = this
    this.cache = new SearchTipsCache()
    if (!this.user.get('id') || this.user.get('is_mature')) {
      this.cache.localStorage._clear()
    }
    this.cache.reset(this.cache.localStorage.findAll())
    old = this.cache.filter(function (element) {
      let timeDiff = (time - parseInt(element.get('time'), 10)) / 1000
      return timeDiff > that.cacheTime
    })
    each(old, function (element) {
      element.destroy()
    })
    this._checkOnCacheMax()
  }
  /**
   * Чистит кэш от самых старых значений при выборе квоты
   * @private
   */
  _checkOnCacheMax () {
    let diff = this.cacheMax - this.cache.length,
      element
    if (diff < 0) {
      diff = Math.abs(diff)
      for (let i = 0; i < diff; i += 1) {
        element = this.cache.at(0)
        if (element) {
          element.destroy()
        }
      }
    }
  }
  /**
   * Останавливает показ подсказок
   */
  abort () {
    this._abortRequest()
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.popup.close()
  }
  /**
   * Останавливает выполнение запущенного запроса к серверу
   * @private
   */
  _abortRequest () {
    if (this.lastRequest && this.lastRequest.readyState > 0 && this.lastRequest.readyState < 4) {
      this.lastRequest.abort()
    }
  }
  /**
   * Обработка нажатий клавиатуры
   */
  keyboardControl () {
    let form = $('.nav-search')
    this.currentSelection = 0
    this.setCurrentUrl('')

    form.keydown(e => {
      if (e.keyCode === KEY_CODES.Enter && this.currentUrl === 'toggleTips') {
        e.preventDefault()
        e.stopPropagation()
        this.toggleTips(e)
      }
    })
    form.keyup(e => {
      e.stopPropagation()
      switch (e.keyCode) {
        case KEY_CODES.ArrowUp:
          this.navigate('up')
          break
        case KEY_CODES.ArrowDown:
          this.navigate('down')
          break
        case KEY_CODES.ArrowRight:
          if (!this.inputFocusedByUser) {
            this.preventCursorMoving(form)
            this.navigate('right')
          }
          break
        case KEY_CODES.ArrowLeft:
          if (!this.inputFocusedByUser) {
            this.preventCursorMoving(form)
            this.navigate('left')
          }
          break
        case KEY_CODES.Enter:
          if (this.currentUrl === 'show') {
            this.$('.js-popup-close').trigger('click')
          } else if (this.currentUrl === 'toggleTips') {
            e.preventDefault()
          } else if (this.currentUrl !== '' && this.currentUrl !== 'searchWithHelpTip') {
            locationAssign(this.currentUrl)
          }
          break
      }
    })
  }

  /**
   * Предотвращает передвижение каретки при навигации по подсказкам
   * @param {jQuery} form
   */
  preventCursorMoving (form) {
    const input = form.find('.search-input'),
      value = input.val()
    input.val('')
    input.val(value)
  }

  /**
   * Организация перемещения по подсказкам.
   * @param {string} direction
   */
  navigate (direction) {
    // Проверяем, не выбран ли какой-либо пункт меню
    if (this.$('.tip.selected').length === 0) {
      this.currentSelection = -1
    }
    this.inputFocusedByUser = false
    this.selectNextElem(this.currentSelection, direction)
    let currentEl = this.$('.tip').eq(this.currentSelection),
      tipsWindow = $('.tips-wrap')
    if (currentEl.length) {
      if (direction === 'down' && currentEl.offset().top > tipsWindow.outerHeight()) {
        tipsWindow.scrollTop(tipsWindow.scrollTop() + currentEl.outerHeight())
      }
      if (direction === 'up' && tipsWindow.outerHeight() - currentEl.offset().top > tipsWindow.scrollTop()) {
        tipsWindow.scrollTop(tipsWindow.scrollTop() - currentEl.outerHeight())
      }
      this.setSelected(this.currentSelection)
    }
  }

  /**
   * Переключение на следующую подсказку.
   * @param {number} position
   * @param {string} direction
   */
  selectNextElem (position, direction) {
    if (direction === 'up' && this.currentSelection !== -1) {
      if (this.currentSelection !== 0) {
        this.currentSelection--
      }
    }
    if (direction === 'down' && this.currentSelection !== this.$('.tip').length - 1) {
      this.currentSelection++
    }
    const selectedTip = this.$('.tip.selected')
    if ((direction === 'right' || direction === 'left') && selectedTip.length) {
      let nextElem = selectedTip.parent().next('.tips-items-column').find('.tip').eq(0)
      if (direction === 'left') {
        nextElem = selectedTip.parent().prev('.tips-items-column').find('.tip').eq(0)
      }
      const nextElemIndex = this.$('.tip').index(nextElem)
      this.currentSelection = nextElemIndex >= 0 ? nextElemIndex : this.currentSelection
    }
    let currentEl = this.$('.tip').eq(this.currentSelection)
    if (currentEl.hasClass('not_display')) {
      if (direction === 'down' && this.currentSelection !== this.$('.tip').length - 1) {
        this.selectNextElem(position + 1, direction)
      } else if (direction === 'up' && this.currentSelection !== 0) {
        this.selectNextElem(position - 1, direction)
      } else {
        this.currentSelection = 1
      }
    }
  }
  /**
   * Устанавливает свойства текущей подсказки.
   * @param {$} menuItem
   */
  setSelected (menuItem) {
    this.$('.tip').removeClass('selected')
    let currentEl = this.$('.tip').eq(menuItem)
    currentEl.addClass('selected')
    this.setCurrentUrl(currentEl.find('a').attr('href'))
    if (currentEl.has('.js-popup-close').length > 0) {
      this.setCurrentUrl('searchWithHelpTip')
    }
    if (currentEl.hasClass('toggle-tips')) {
      this.setCurrentUrl('searchWithHelpTip')
    }
    if (currentEl.find('.js-help-tip').length) {
      Backbone.trigger('set-tip-to-input', null, currentEl.find('a').text().trim())
      this.setCurrentUrl('searchWithHelpTip')
    }
  }
  /**
   * Обработчик свертывания подсказок в поиске
   * @param {Event} e событие клика либо селектор(при рендере).
   */
  toggleTips (e) {
    let $tips = e ? $(e.currentTarget).parents('ul') : $('.tips-select')
    if (!this.stateCountTips) {
      if ($('.tips-wrap').find('li:not(.h4)').length <= 12) {
        this.stateTips.Category = false
        this.stateTips.Trademarks = false
      }
    }
    if (e) {
      if (e.keyCode === KEY_CODES.Enter) {
        $tips = $('a.selected, li.selected').parents('ul')
        let showAllButton = $tips.children('.toggle-tips')
        this._changeLinkLabel(null, showAllButton)
      } else {
        this._changeLinkLabel(e)
      }
      this._toggling($tips)
      this.stateCountTips = true
      if ($tips.hasClass('categories')) {
        this.stateTips.Category = !this.stateTips.Category
      } else {
        this.stateTips.Trademarks = !this.stateTips.Trademarks
      }
    } else {
      $tips.each((i, el) => {
        if ($(el).hasClass('categories')) {
          this.stateTips.Category ? this._toggling($(el)) : this._changeLinkLabel(false, $('a.tips-category'))
        } else {
          this.stateTips.Trademarks ? this._toggling($(el)) : this._changeLinkLabel(false, $('a.tips-trademarks'))
        }
      })
    }
    this.calculateItemWidth()
  }
  /**
   * Сворачивает/разворачивает подсказки
   * @param {$} $tips селектор того что нужно обернуть.
   * @private
   */
  _toggling ($tips) {
    $tips.each((i, el) => {
      let tips = $(el).find('li:not(.h4)'),
        length = tips.length
      for (let j = this.maxTipsShow; j < length; j++) {
        tips.eq(j).toggleClass('not_display')
      }
    })
  }
  /**
   * Смена линк-лэйбла в попапе подсказок
   * @param {Event} e
   * @param {string} state селектор на линк-лэйбл
   * @private
   */
  _changeLinkLabel (e, state) {
    let $target = e ? $(e.currentTarget) : state
    let isOpen = $target.hasClass('open')

    $target
      .html(this.showAllTemplateBtn({ open: !isOpen }))
      .toggleClass('open', !isOpen)
  }
  /**
   * Рассчитывает ширину имен товаров
   */
  calculateItemWidth () {
    this.$('.items li a').each((i, el) => {
      $(el).css('width', 'auto')
      if ($(el).outerWidth() > $(el).parent().width() - $(el).find('.price').outerWidth()) {
        $(el).css({
          width: $(el).parent().width() - $(el).find('.price').outerWidth(),
        }).addClass('elipsis')
      }
    })
  }
  /**
   * Закрывает себя или другие вью при пересечении
   */
  closeManager () {
    Backbone.trigger('close-header-search-hint')
    Backbone.once('close-search-slide-selector', () => {
      this.close()
    })
  }

  /**
   * Удаляет поисковый запрос из LocalStorage.
   * @param {Event} [e]
   */
  deleteRequestHistoryFromLS (e) {
    let savedRequest = $(e.currentTarget).data('request-history'),
      requests = LS.get('saved_requests')

    if (savedRequest) {
      remove(requests, function (request) {
        return request.query === savedRequest
      })
    } else {
      requests = []
    }

    LS.set(
      'saved_requests',
      requests,
      function () {
        localStorage.clear()
        LS.set('saved_requests', requests)
      })
    this.renderRequests()
  }
}
